var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import moment from "moment";
import { HorizonJs_Uuid } from "horizon-js-sdk/lib/HorizonJs_Uuid";
var PurchaseItemStatusUpdate = /** @class */ (function (_super) {
    __extends(PurchaseItemStatusUpdate, _super);
    function PurchaseItemStatusUpdate(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.date = new Date();
        _this.status = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        PurchaseItemStatusUpdate.buildFromJson(_this, obj);
        return _this;
    }
    PurchaseItemStatusUpdate.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                instance[prop] = json[prop];
            }
        }
    };
    PurchaseItemStatusUpdate.prototype.search_uid = function (uid) {
        if (this.uid === uid) {
            return this;
        }
        return null;
    };
    PurchaseItemStatusUpdate.prototype.exportToJson = function () {
        var JSONPurchase = {};
        JSONPurchase.uid = this.uid;
        JSONPurchase.purchaseItemUid = this.purchaseItemUid;
        JSONPurchase.statusUid = this.statusUid;
        JSONPurchase.orderUid = this.orderUid;
        JSONPurchase.date = moment(this.date).format('YYYY-MM-DDTHH:mm:ssZZ');
        JSONPurchase.status = this.status;
        return JSONPurchase;
    };
    PurchaseItemStatusUpdate.prototype.generateUid = function (allChilds) {
        if (allChilds === void 0) { allChilds = false; }
        if (this.uid === null) {
            this.uid = HorizonJs_Uuid.v4();
        }
    };
    return PurchaseItemStatusUpdate;
}(Model));
export { PurchaseItemStatusUpdate };
//# sourceMappingURL=PurchaseItemStatusUpdate.js.map